import { Favorites } from './components/Favorites/Favorites'
import Styles from './FileTreeLocationPicker.module.scss'
import { LocationPickerFolder, SelectedFolder } from 'components/LocationPicker/LocationPicker'
import { Projects } from './components/Projects/Projects'
import { NavItem } from 'components/NavItem'
import HandbookItemsStyles from './components/HandbookItems/HandbookItems.module.scss'
import { Check } from 'blaze-ui/icons/16'
import Folder from 'blaze-ui/icons/20/Folder'
import { LoadingState } from './components/LoadingState/LoadingState'
import { useFiles } from 'hooks/queries/finder/useFiles'

export const FileTreeLocationPicker = ({
  workspaceId,
  onSelect,
  activeFolder,
  isRootDisabled = false,
  isCreateDisabled = false,
  disabledFolderIds = [],
  inModal = false,
}: {
  workspaceId: number
  onSelect: (folder: SelectedFolder | null) => void
  activeFolder: LocationPickerFolder | null | undefined
  isRootDisabled?: boolean
  disabledFolderIds?: string[]
  inModal?: boolean
  isCreateDisabled?: boolean
}) => {
  // Check loading state for projects data
  const projectsQuery = useFiles({
    location: 'projects',
    workspaceId,
    query: { items: 50 },
    disableSchema: true,
  })

  const isLoading = projectsQuery.isLoading || (projectsQuery.isFetching && !projectsQuery.data)

  return (
    <div className={Styles.container}>
      {isLoading ? (
        <LoadingState />
      ) : (
        <ul>
          {!isRootDisabled && (
            <NavItem.Root
              isActive={!activeFolder?.id}
              elementType="div"
              noMargin
              onPress={() => {
                onSelect(null)
              }}
            >
              <NavItem.Emoji>
                <Folder />
              </NavItem.Emoji>
              <NavItem.Label label="All Files" />
              {!activeFolder?.id && (
                <div className={HandbookItemsStyles.checkIcon}>
                  <Check />
                </div>
              )}
            </NavItem.Root>
          )}
          {!inModal && (
            <Favorites workspaceId={workspaceId} onSelect={onSelect} disabledFolderIds={disabledFolderIds} />
          )}
          <Projects
            workspaceId={workspaceId}
            onSelect={onSelect}
            activeFolder={activeFolder}
            isRootDisabled={isRootDisabled}
            isCreateDisabled={isCreateDisabled}
            disabledFolderIds={disabledFolderIds}
            inModal={inModal}
          />
        </ul>
      )}
    </div>
  )
}
